<template>
  <transition name="slide" :duration="duration">
    <div v-show="show" class="modal-container">
      <div class="modal">
        <div class="modal-dialog" :class="'modal-sm'">
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <div class="modal-title">
                <div>Enter PIN to update data</div>
              </div>
            </div>
            <!--Container-->
            <div class="modal-body">
              <div class="form-group">
                <input type="password" class="form-control" placeholder="Enter PIN" v-model="pin">
                <span class="error" v-if="error!==''">Please enter correct PIN</span>
              </div>
            </div>
            <!--Footer-->
            <div class="modal-footer">
              <button type="button" class="mt-3" :class="'btn btn-primary'" @click="ok">Sumbit</button>
              <button
                type="button"
                class="mt-3"
                :class="'btn btn-secondary'"
                @click="cancel"
                data-dismiss="modal"
              >Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop"></div>
    </div>
  </transition>
</template>
<script>
import VueJwtDecode from "vue-jwt-decode";
import http from "@/lib/http";
export default {
  name: "PIN-modal",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary"
    },
    cancelClass: {
      type: String,
      default: "btn btn-secondary"
    }
  },
  data() {
    return {
      show: false,
      duration: 200,
      pin: "",
      error: ""
    };
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    );
  },
  watch: {
    show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    }
  },
  methods: {
    ok() {
      console.log("PIN", this.pin);
      var j = VueJwtDecode.decode(localStorage.getItem("token"));
      console.log("Token decoded", j);
      // this.$emit("submitPin", { pin: this.pin, user: j.identity.id });
      this.validatePin({ pin: this.pin, user: j.identity.id });
      //this.show = false
    },
    cancel() {
      this.$emit("cancel");
      this.show = false;
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
    },
    validatePin(pin) {
      this.error = "";
      var _this = this;
      console.log("pin entered", pin);
      http.post("checkPin/" + pin.user, { pin: pin.pin }, (error, response) => {
        console.log("submitted pin", response);
        if (response.responseType === "success") {
          _this.error = "";
          _this.show = false;
          _this.pin = '';
          _this.$emit("submitForm");
        } else {
          _this.error = response.message;
        }
      });
    }
  }
};
</script>
<style lang="scss">
span.error{
  color: #dc3545;
}
// For Transitioning
.slide-enter-active {
  animation: slide-in 3s fade forwards;
}
.slide-leave-active {
  animation: slide-out 3s fade forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(250px);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(250px);
  }
}

.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

//Modal styles

.modal-header {
  height: 55px;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;
  .btn {
    margin: 0 10px 20px 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/PinCheck.vue